import { Team } from "./Team";

export enum AuthProvider {
  Slack = "slack",
  Teams = "teams",
}

export interface User {
  email: string;
  id: string;
  authProvider: AuthProvider;
  name: string;
  profilePictureUrl: string;
  team: Team;
}
